import { FONT_COPY, FONT_ITALIC, FONT_SUBTITLE, FONT_TITLE } from '../constants/AppConstants';

export default class CopyController {
  constructor(game, xml, levelDialogue) {
    this.copy = {};
    this.game = game;
    this.levelDialogue = levelDialogue;
    const nodes = xml.getElementsByTagName('item');
    for (let i = 0; i < nodes.length; i++) {
      this.copy[nodes[i].getAttribute('id')] = nodes[i].childNodes[0].nodeValue;
    }
  }

  setElinorCopy(xml) {
    const nodes = xml.getElementsByTagName('item');
    this.elinorCopy = {};
    for (let i = 0; i < nodes.length; i++) {
      this.elinorCopy[nodes[i].getAttribute('id')] = nodes[i].childNodes[0].nodeValue;
    }
  }

  setSceneCopy(xml) {
    const nodes = xml.getElementsByTagName('item');
    this.sceneCopy = {};
    for (let i = 0; i < nodes.length; i++) {
      this.sceneCopy[nodes[i].getAttribute('id')] = nodes[i].childNodes[0].nodeValue;
    }
  }

  getElinorCopy(id, deviceAlt) {
    if (deviceAlt && this.elinorCopy[id + '_device']) {
      return this.elinorCopy[id + '_device'];
    }
    return this.elinorCopy[id] || '';
  }

  getSceneCopy(id, deviceAlt) {
    if (deviceAlt && this.sceneCopy[id + '_device']) {
      return this.sceneCopy[id + '_device'];
    }
    return this.sceneCopy[id] || '';
  }

  getCopy(id, deviceAlt) {
    if (deviceAlt && this.copy[id + '_device']) {
      return this.copy[id + '_device'];
    }
    return this.copy[id] || 'copy not found [ ' + id + ' ]';
  }

  getCopyNoDefault(copyID) {
    return this.copy[copyID] || null;
  }

  getFontFamily(title, fontsize) {
    return title ? fontsize + 'px ' + FONT_TITLE : fontsize + 'px ' + FONT_COPY;
  }

  createFontStyle(titleFont, fontSize, fontColour, options = {}) {
    return {
      font: this.getFontFamily(titleFont, fontSize),
      fill: fontColour,
      boundsAlignH: options.boundsAlignH || 'center',
      boundsAlignV: options.boundsAlignV || 'middle',
      ...options,
    };
  }

  createSubtitleFontStyle(fontSize, fontColour, options = {}) {
    return {
      font: fontSize + 'px ' + FONT_SUBTITLE,
      fill: fontColour,
      boundsAlignH: options.boundsAlignH || 'center',
      boundsAlignV: options.boundsAlignV || 'middle',
      ...options,
    };
  }

  createSetUpFontStyle(fontSize, fontColour, options = {}) {
    return {
      font: fontSize + 'px ' + FONT_ITALIC,
      fill: fontColour,
      boundsAlignH: options.boundsAlignH || 'center',
      boundsAlignV: options.boundsAlignV || 'middle',
      ...options,
    };
  }

  getLevelDialogue(level) {
    return this.levelDialogue[level];
  }

  getGameDialogue(gameId) {
    return this.game.cache.getJSON('dialogue_' + gameId);
  }

  getGameIntroDialogue(gameId) {
    const gameDialogue = this.getGameDialogue(gameId);
    return gameDialogue ? gameDialogue.intro : false;
  }

  getGameOutroDialogue(gameId, levelState) {
    const gameDialogue = this.getGameDialogue(gameId);
    if (gameDialogue) {
      return gameDialogue.outro[levelState] || false;
    }
    return false;
  }

  getCharacterName(id) {
    return this.getCopy(id);
  }

  getHowToPlayCopy() {
    let page = 0;
    const results = [];
    while (page < 1) {
      const title = this.copy['howtoplay_' + (page + 1) + '_title'];
      const copy = this.copy['howtoplay_' + (page + 1) + '_copy'];
      results.push({ title, copy });
      page++;
    }
    return results;
  }
}
